import React from 'react';
import { Form, Select, Col } from 'antd';
import { QuestionMark } from '../QuestionMark';

interface NoteTypeSelectProps {
    initialValue?: string;
    required?: boolean;
    onUpdate: (field: string, value: any) => void;
}

const noteTypeOptions = [
    {
        value: 'Manufacturing Note/Question',
        label: <span>Manufacturing Note/Question</span>,
    },
    {
        value: 'Price/Lead Time Review Request or Target',
        label: <span>Price/Lead Time Review Request or Target</span>,
    },
    {
        value: 'Refresh Note Critical for Quote Completion',
        label: <span>Refresh Note Critical for Quote Completion</span>,
    },
    {
        value: 'FYI/Record-keeping Only',
        label: <span>FYI/Record-keeping Only</span>,
    },
];

export const NoteTypeSelect: React.FC<NoteTypeSelectProps> = ({ initialValue, required = true, onUpdate }) => {
    return (
        <Col md={24} span={24}>
            <Form.Item
                name="note_type"
                label={
                    <span>
                        Note Type
                        <QuestionMark>
                            Select the type of note to properly categorize this quote for processing
                        </QuestionMark>
                    </span>
                }
                rules={[
                    {
                        required: required,
                        message: 'Please select a note type',
                    },
                ]}
                initialValue={initialValue}
            >
                <Select
                    placeholder="Select note type"
                    options={noteTypeOptions}
                    onChange={value => {
                        onUpdate('note_type', value);
                    }}
                />
            </Form.Item>
        </Col>
    );
};
